import Products from "../components/Products"

const Home = () => {
    return (
        <>
            <div className="hero py-16 bg-gray-900 text-white mt-4">
                <div className="container mx-auto flex items-center">
                    <div className="w-full md:w-1/2 text-center md:text-left">
                        <h6 className="text-lg"><em>Feeling Hungry?</em></h6>
                        <h1 className="text-3xl md:text-6xl font-bold mt-2">Order Delicious Food Now</h1>
                        <p className="mt-4 text-lg">Explore a wide range of mouth-watering dishes and satisfy your cravings.</p>
                        <button className="px-8 py-3 mt-8 bg-yellow-500 hover:bg-yellow-600 rounded-full text-xl font-bold focus:outline-none">Order Now</button>
                    </div>
                    <div className="hidden md:block md:w-1/2 md:pl-12">
                        <img src="/images/cover.jpg" alt="restaurant-img" className="w-full rounded-lg shadow-lg" />
                    </div>
                </div>
            </div>
            <div className="pb-24">
                <Products />
            </div>
        </>

    )
}

export default Home
